import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

export async function GET(_: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params

  const article = await queryOne(`
    SELECT a.*, c.name as category_name, c.color as category_color
    FROM articles a LEFT JOIN categories c ON a.category_id = c.id
    WHERE a.id = ?
  `, [id])

  if (!article) return NextResponse.json({ error: 'Not found' }, { status: 404 })

  const stats = await queryOne<{ total_vendu: number; ca: number; benefice: number }>(`
    SELECT
      SUM(vl.quantite) as total_vendu,
      SUM(vl.prix_unitaire * vl.quantite) as ca,
      SUM((vl.prix_unitaire - vl.ras_mel_unitaire) * vl.quantite) as benefice
    FROM vente_lignes vl WHERE vl.article_id = ?
  `, [id])

  return NextResponse.json({
    ...article,
    category: article.category_name ? { name: article.category_name, color: article.category_color } : null,
    stats: stats?.total_vendu ? stats : null,
  })
}

export async function PUT(req: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  const body = await req.json()
  await query(`
    UPDATE articles SET
      name = ?, barcode = ?, category_id = ?,
      ras_mel = ?, prix_vente = ?, prix_min = ?,
      stock_alert = ?, unit = ?
    WHERE id = ?
  `, [body.name, body.barcode || null, body.category_id || null,
      body.ras_mel, body.prix_vente, body.prix_min,
      body.stock_alert, body.unit, id])

  return NextResponse.json({ ok: true })
}

export async function DELETE(_: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  await query('DELETE FROM articles WHERE id = ?', [id])
  return NextResponse.json({ ok: true })
}

export async function PATCH(req: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  const { shop_id, user_id, type, quantite, note, current_stock } = await req.json()

  const newStock = type === 'entree'
    ? current_stock + quantite
    : Math.max(0, current_stock - quantite)

  await query('UPDATE articles SET stock = ? WHERE id = ?', [newStock, id])
  await query(
    'INSERT INTO stock_mouvements (id, shop_id, article_id, user_id, type, quantite, note) VALUES (?, ?, ?, ?, ?, ?, ?)',
    [uuid(), shop_id, id, user_id, type, type === 'entree' ? quantite : -quantite, note || null]
  )

  return NextResponse.json({ ok: true, new_stock: newStock })
}
